const moment = require("moment");

const config = require("./Config.js");
const store = require("./store.js");

const UploadHistoryActionCreators = require("./actionCreators/UploadHistoryActionCreators.js");

const theEndOfTime = new Date("12/31/2037").getTime();
const defaultIntervalMs = config.HistoryTickerIntervalMs || 10000;

const HistoryTicker = {
    LatestTickerHandle: 0,
    StopTickingAfterTime: 0,
    Start() {
        store.subscribe(HistoryTicker.OnStateChanged);

        UploadHistoryActionCreators.GetRecent();
    },
    OnStateChanged() {
        const state = store.getState();

        const isInError = state.History.Error !== null;
        const isUploadWorking = state.Upload.IsWorking;
        const isHistoryLoading = state.History.IsLoading;
        const allAreComplete = HistoryTicker.AreAllUploadsComplete(state.History.Data);
        
        if (isInError || allAreComplete) {
            console.log("don't tick");

            HistoryTicker.DontTickAgain();

            return;
        }

        if (isUploadWorking || !allAreComplete) {
            console.log("tick indefinitely");

            HistoryTicker.TickIndefinitely(isHistoryLoading);

            return;
        }

        console.log("tick status inconclusive; don't tick");

        HistoryTicker.DontTickAgain();
    },
    AreAllUploadsComplete(currentHistory) {
        if ((currentHistory || []).length === 0) {
            return true;
        }

        for (var i = 0; i < currentHistory.length; i++) {
            if (!currentHistory[i].Completed) {
                return false;
            }
        }

        return true;
    },
    DontTickAgain() {
        HistoryTicker.StopTickingAfterTime = 0;
    },
    TickIndefinitely(isHistoryLoading) {
        HistoryTicker.StopTickingAfterTime = theEndOfTime;

        HistoryTicker.TryTick();
    },
    /**
     * Checks whether ticking is allowed; if it is, performs a refresh
     * after an optionally specified delay
     */
    TryTick(isHistoryLoading) {
        const now = new Date().getTime();
        
        if (HistoryTicker.StopTickingAfterTime >= now) {
            const isTicking = HistoryTicker.LatestTickerHandle !== 0;

            if (isTicking) {
                clearInterval(HistoryTicker.LatestTickerHandle);
            }

            HistoryTicker.LatestTickerHandle =
                setTimeout(HistoryTicker.OnTick, defaultIntervalMs, isHistoryLoading);
        }
    },
    OnTick(isHistoryLoading) {
        console.log("TICK");

        // A tick has occurred; clear the handle.
        HistoryTicker.LatestTickerHandle = 0;

        // No simultaneous loading.
        if (!isHistoryLoading) {
            UploadHistoryActionCreators.GetRecent();
        }

        // Whether we load or not, try to tick again
        HistoryTicker.TryTick();
    }
};

module.exports = HistoryTicker;


// WEBPACK FOOTER //
// ./src/HistoryTicker.js